import { Box, Button, Stack, styled, Typography } from '@mui/material';

export const StripeContainer = styled(Box)(({ theme }) => ({
  maxWidth: theme.typography.pxToRem(520),
}));

export const StripeCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.typography.pxToRem(12),
  padding: theme.spacing(3),
  boxShadow: theme.shadows[1],
}));

export const StripeLogo = styled('img')({
  height: 32,
  width: 'auto',
  objectFit: 'contain',
});

export const CardTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  fontWeight: 600,
  marginTop: theme.spacing(2),
}));

export const CardDescription = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(1),
}));

export const StatusRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.palette.action.hover,
  borderRadius: theme.typography.pxToRem(8),
}));

export const StatusLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.secondary,
  minWidth: theme.typography.pxToRem(120),
}));

export const StatusValue = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: 500,
  color: theme.palette.text.primary,
}));

export const CountrySelect = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& .MuiFormControl-root': {
    minWidth: theme.typography.pxToRem(200),
  },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  textTransform: 'none',
  fontWeight: 600,
  padding: theme.spacing(1, 3),
}));

export const StatusBadge = styled(Box)<{ status: 'success' | 'warning' | 'error' }>(
  ({ theme, status }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.typography.pxToRem(16),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    ...(status === 'success' && {
      backgroundColor: theme.palette.success.light,
      color: theme.palette.success.contrastText,
    }),
    ...(status === 'warning' && {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText,
    }),
    ...(status === 'error' && {
      backgroundColor: theme.palette.error.light,
      color: theme.palette.error.contrastText,
    }),
  }),
);

export const Divider = styled(Box)(({ theme }) => ({
  height: 1,
  backgroundColor: theme.palette.divider,
  margin: theme.spacing(3, 0),
}));

export const ErrorCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.typography.pxToRem(12),
  padding: theme.spacing(3),
  boxShadow: theme.shadows[1],
  maxWidth: theme.typography.pxToRem(520),
  textAlign: 'center',
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.error.main,
  marginBottom: theme.spacing(2),
}));
